import '../../../external/jquery.fancybox.min.js';

export const initFancybox = () => {
    return null
};

/*
    $('a.afg-fb').fancybox({
        closeBtn: false,
        nextEffect: 'fade',
        prevEffect: 'fade',
        nextSpeed: 'slow',
        prevSpeed: 'slow',
        helpers: {
            title: { type: 'inside' },
        },

        beforeShow: function() {
            //id = $(this).attr("id");
            //var down = $(this).attr("title");
            var title = $(this).attr("title");
            var res = title.split("|");
            var down = res[0];
            var id = res[1];
            var min = $(this).attr("href").replace("_b.", "_s.");
            min = encodeURI(min);

            // $(this).attr({
            //     title: '&nbsp;<span style="float:right;">' +
            //         '<a onClick="window.open(\'http://www.facebook.com/dialog/feed?app_id=294733833984572&link=' + TXT_url_face + '%3Fimg%3D' + id + '&amp;picture=' + min + '&amp;name=' + TXT_name_face + '&amp;description=' + TXT_desc_face + '&amp;display=popup&amp;redirect_uri=' + TXT_uri_face + '\',\'sharer\',\'toolbar=0,status=0,width=580,height=400\');" href="javascript:void(0)"><img src="' + TXT_template_url + '/img/iconFacebook.png" width="25px"/></a>' +
            //         '&nbsp' +
            //         '<a href="http://twitter.com/intent/tweet?text=' + TXT_desc_twit + ' ' + TXT_url_face + '%3Fimg%3D' + id + '" target="_blank" class="share_twit"><img src="' + TXT_template_url + '/img/iconTwitter.png" width="25px"/></a>' +
            //         '</span>'
            // });
            $(this).attr({
                title: ''
            });
            
        }
        

    });
    */